<template>
  <div class="pt-50">
    <div @click="handleShowSidebar" class="mt-3 mb-3">
      <b-button v-if="isMobile" variant="transparent" class="float-left mt-n1 d-inline-block">
        <img src="@/assets/icons/chevron-left.svg" width="20" height="20" />
      </b-button>
    </div>

    <div class="mt-50">
      <h1 class="text-capitalize text-center">{{ getGreeting() }}, {{ firstName }}</h1>
      <p class="text-center">What can I help you with?</p>

      <div class="mt-5 pt-3 pl-3 pr-3 pb-4 bg-light border rounded">
        <tiptap-message
          ref="query"
          @success="triggerCreateTask"
          :value.sync="content"
          :placeholder="
            `Ask a legal question, conduct research, or provide case details...` | __t('first-message__ask-a-legal-question')
          "
        />

        <div>
          <b-button
            @click="triggerCreateTask"
            variant="warning"
            class="mt-4 pl-3 pr-3 rounded text-white text-uppercase font-weight-bold float-right"
            pill
          >
            <img src="@/assets/icons/send.svg" width="20" height="20" class="mr-2" />
            {{ "Continue" | __t("first-message__continue") }}
          </b-button>

          <task-focus :resources.sync="resources" :is-smart-search.sync="isSmartSearch" class="float-left" />
        </div>
        <task-attachment :attachments.sync="attachments" :is-showing-title="true" class="mt-4" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CREATE } from "@/store/actions";

import { BButton } from "bootstrap-vue";

import { CHATBOT_MESSAGE_TYPE, CHATBOT_ROLES } from "@/constants/aiChat";

import { getGreeting } from "@/helpers/strings";

import TiptapMessage from "@/components/Forms/TipTap/Message";
import TaskFocus from "./Focus/";
import TaskAttachment from "./Attachment/";

export default {
  name: "TaskWizard",
  components: { BButton, TiptapMessage, TaskFocus, TaskAttachment },
  computed: {
    ...mapState({ firstName: (state) => state.auth.user.private?.firstName }),
    projectId() {
      return this.$route.params.projectId;
    },
    isMobile() {
      const { value } = this.$screen.alias;
      return value === "xs" || value === "sm" || value === "md";
    },
  },
  data: () => ({
    content: "",

    resources: [],
    attachments: [],
    isSmartSearch: true,

    isSending: false,
  }),
  mounted() {
    this.$refs.query.handleFocus();
  },
  methods: {
    ...mapActions("projectsTasks", { createTask: CREATE }),
    ...mapActions("projectsTasksDiscussions", { createMessage: CREATE }),
    async triggerCreateTask() {
      this.isSending = true;

      const { projectId, content, attachments, resources, isSmartSearch } = this;
      const settings = { country: "france", attachments, resources, isSmartSearch };

      const { id: taskId } = await this.createTask({ projectId, settings, content });

      const role = CHATBOT_ROLES.USER;
      const format = CHATBOT_MESSAGE_TYPE.TEXT;

      await this.createMessage({ projectId, taskId, settings, content, role, format });

      this.$router.push({ name: "ProjectTask", params: { taskId } });

      this.isSending = false;
    },

    handleShowSidebar() {
      this.$bus.emit("show-sidebar");
    },

    getGreeting,
  },
};
</script>
